module.exports = __webpack_public_path__ + "img/SUPACell.d71053dd.png";